import client from '@/http'

const loadAll = (context) => {
  client.get(
    'processes'
  ).then(
    res => {
      context.commit('SET_RUNNING', res.data)
    }
  ).catch(
    e => {
      console.error(e)
    }
  )
}

const kill = (context, key) => {
  client.delete(
    `processes/${key}`
  ).then(
    context.commit('REMOVE', key)
  ).catch(e => {
    console.error(e)
  })
}

export default {
  kill,
  loadAll
}
